import { fileUrl } from "../lib/api";

/**
 * Standardized product media wrapper: locked 2584:1516 aspect ratio,
 * object-cover (center), responsive srcset + lazy loading.
 * Use everywhere a product cover image appears.
 */
export default function ProductImage({ src, alt, size = "card", className = "", priority = false }) {
  const url = fileUrl(src);
  const isFileApi = url && url.includes("/api/files/");
  // Base widths per usage
  const widths = size === "detail" ? [1292, 2584] : size === "thumb" ? [200, 400] : [646, 1292];
  const sizes = size === "detail"
    ? "(max-width: 768px) 100vw, 800px"
    : size === "thumb"
      ? "80px"
      : "(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 320px";

  const srcSet = isFileApi
    ? widths.map((w) => `${url}?w=${w} ${w}w`).join(", ")
    : undefined;
  const baseSrc = isFileApi ? `${url}?w=${widths[0]}` : url;

  return (
    <div
      className={`relative overflow-hidden ${className}`}
      style={{ aspectRatio: "2584 / 1516" }}
    >
      {url ? (
        <img
          src={baseSrc}
          srcSet={srcSet}
          sizes={sizes}
          alt={alt || ""}
          width={2584}
          height={1516}
          loading={priority ? "eager" : "lazy"}
          fetchpriority={priority ? "high" : "auto"}
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
      ) : (
        <div className="absolute inset-0 w-full h-full bg-[#24262B]" />
      )}
    </div>
  );
}
